import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

function Header() {
  const location = useLocation();

  useEffect(() => {
    // Logo scroll effect
    const handleScroll = () => {
      const logo = document.getElementById("scrollHeaderLogo");
      if (logo) {
        if (window.scrollY > 50) {
          logo.src = "/img/logo.gif";
        } else {
          logo.src = "/img/logo.gif";
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Function to determine if a nav item is active
  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  return (
    <>
      {/* Topbar Start */}
      <div className="container-fluid bg-dark px-5 d-none d-lg-block">
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
            <div className="d-inline-flex align-items-center" style={{height: "45px"}}>
              <small className="me-3 text-light">
                <i className="fa fa-map-marker-alt me-2"></i> CBD Building, Near Sharaf DG Metro Station, Dubai, UAE.
              </small>
              <small className="me-3 text-light">
                <i className="fa fa-phone-alt me-2"></i>+971 55 730 6504
              </small>
              <small className="text-light">
                <i className="fa fa-envelope-open me-2"></i> info@brandliftmm.com
              </small>
            </div>
          </div>
          <div className="col-lg-4 text-center text-lg-end">
            <div className="d-inline-flex align-items-center" style={{height: "45px"}}>
              <button
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                onClick={() => window.open('https://twitter.com', '_blank')}
              >
                <i className="fab fa-twitter fw-normal"></i>
              </button>
              <button
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                onClick={() => window.open('https://facebook.com', '_blank')}
              >
                <i className="fab fa-facebook-f fw-normal"></i>
              </button>
              <button
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                onClick={() => window.open('https://linkedin.com', '_blank')}
              >
                <i className="fab fa-linkedin-in fw-normal"></i>
              </button>
              <button
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                onClick={() => window.open('https://instagram.com', '_blank')}
              >
                <i className="fab fa-instagram fw-normal"></i>
              </button>
              <button
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle"
                onClick={() => window.open('https://youtube.com', '_blank')}
              >
                <i className="fab fa-youtube fw-normal"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Topbar End */}

      {/* Navbar & Carousel Start */}
      <div className="container-fluid position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
          <Link to="/" className="navbar-brand p-0">
            <img src="/img/logo.gif" className="h-30 w-20" id="scrollHeaderLogo" alt="Brand Lift Logo" style={{borderRadius: "15px"}} />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link to="/" className={`nav-item nav-link ${isActive("/")}`}>Home</Link>
              <Link to="/about" className={`nav-item nav-link ${isActive("/about")}`}>About</Link>
              <Link to="/services" className={`nav-item nav-link ${isActive("/services")}`}>Services</Link>
              <Link to="/blog" className={`nav-item nav-link ${isActive("/blog")}`}>Blog</Link>
              <Link to="/contact" className={`nav-item nav-link ${isActive("/contact")}`}>Contact</Link>
            </div>
            <button
              type="button"
              className="btn text-primary ms-3"
              data-bs-toggle="modal"
              data-bs-target="#searchModal"
            >
              <i className="fa fa-search"></i>
            </button>
            <a
              href="https://www.brandliftmm.com/free-quote"
              className="btn btn-primary py-2 px-4 ms-3">
              Appointment
            </a>
          </div>
        </nav>
      </div>
      {/* Navbar & Carousel End */}

      {/* Full Screen Search Start */}
      <div className="modal fade" id="searchModal" tabIndex="-1">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content" style={{ backgroundColor: "rgba(9, 30, 62, 0.7)" }}>
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn bg-white btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body d-flex align-items-center justify-content-center">
              <div className="input-group" style={{ maxWidth: "600px" }}>
                <input
                  type="text"
                  className="form-control bg-transparent border-primary p-3"
                  placeholder="Type search keyword"
                />
                <button className="btn btn-primary px-4">
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Full Screen Search End */}
    </>
  );
}

export default Header;
